import React from 'react';
import { getLanguages } from '../../services';
import { PropTypes } from 'prop-types';

export const ProductPage = ( { title } ) => {
  const culture = getLanguages().first();
  return <iframe id="popupContent" name="popupContent" src={ `${document.location.protocol}//new.abb.com/products/${culture}/${title}` } />;
};

ProductPage.propTypes = {
  title: PropTypes.string.isRequired
};